// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderStatusFormStyles } from "@insite/content-library/Widgets/OrderStatus/OrderStatusForm";
import { css } from "styled-components";

orderStatusFormStyles.form = {
    css: css`
        display: flex;
        align-items: inherit;
        flex-wrap: wrap;
        @media (max-width: 600px) {
            justify-content: space-between;
        }
    `,
};
orderStatusFormStyles.orderNumberTextField = {
    cssOverrides: {
        formField: css`
            width: 278px;
            margin-right: 30px;
            @media (max-width: 600px) {
                margin-right: 0;
            }
            @media (max-width: 481px) {
                width: 100%;
            }
        `,
    },
};
orderStatusFormStyles.emailOrPostalCodeTextField = {
    cssOverrides: {
        formField: css`
            width: 278px;
            margin-right: 30px;
            @media (max-width: 600px) {
                margin-right: 0;
            }
            @media (max-width: 481px) {
                width: 100%;
                margin-top: 10px;
            }
        `,
    },
};

orderStatusFormStyles.submitButtonGridItem = {
    width: [12, 12, 12, 12, 2],
    css: css`
        align-items: end;
    `,
};

orderStatusFormStyles.submitButton = {};
